import * as THREE from "three";

export enum AttributeSize {
  Float = 1,
  Vec2 = 2,
  Vec3 = 3,
  Vec4 = 4
}

export interface IBatchConfig<TLayout extends Record<string, AttributeSize> = any>
{
  max_instances: number;
  layout?: TLayout;
  blend_mode?: THREE.Blending;
  enable_z_sort?: boolean;
}

export enum InstanceState 
{
  Alive    = 0,
  Stopping = 1,
  Dead     = 2,
}
